module.exports = __webpack_public_path__ + "img/1275dac.jpg";